module.exports = __webpack_public_path__ + "img/management-services-img1.2caaab4b.png";